import React, { forwardRef } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MUISelect from "@mui/material/Select";
const Select = forwardRef(({ onChange, isFullWidth = false, shrinkLabel, "aria-label": ariaLabel, children, ...props }, ref) => {
    const selectComponent = (React.createElement(MUISelect, { ref: ref, fullWidth: isFullWidth, onChange: (event) => onChange(event.target.value), notched: shrinkLabel !== undefined ? shrinkLabel : props.notched, ...props, inputProps: { ...props.inputProps, "aria-label": ariaLabel } }, children));
    if (props.label && props.labelId) {
        return (React.createElement(FormControl, { fullWidth: isFullWidth, ref: ref, variant: props.variant },
            React.createElement(InputLabel, { id: props.labelId, shrink: shrinkLabel }, props.label),
            selectComponent));
    }
    else {
        return selectComponent;
    }
});
Select.displayName = "Select";
export default Select;
//# sourceMappingURL=Select.js.map